export enum FilterCharactType {
  TUMOR_ENTITY = 'tumorEntity',
  TUMOR_REGION = 'tumorRegion',
  TUMOR_CATEGORY = 'tumorCategory',
  CONDITION = 'icd',
  INTERVENTION = 'drug',
  SUBTYPE = 'subtypes',
  UICC = 'uiccs',
  GENE_WILDTYPE = 'wildtypegenes',
  GENE_MUTATED = 'mutatedgenes',
  BIOMARKER = 'biomarkers',
  LINE_OF_TREATMENT = 'lineoftreatment',
  TUMOR_MUTATIONAL_BURDEN = 'tmb',
  ADJUVANT = 'adjuvant',
  PATHWAY = 'pathway',
  PROTEIN_CHANGE = 'proteinChange',
  UNKNOWN = 'unknown',
}
